import React from 'react';
import PropTypes from 'prop-types';
import { alpha, useTheme } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import IconBadge from './IconBadge';

const SectionHeader = ({
  overline,
  title,
  subtitle,
  icon,
  align = 'center',
  maxWidth = '100%',
}) => {
  const theme = useTheme();

  return (
    <Box textAlign={align} marginBottom={{ xs: 4, md: 5 }} maxWidth={maxWidth} marginX={align === 'center' ? 'auto' : 0}>
      {icon ? (
        <Box display="flex" justifyContent={align === 'center' ? 'center' : 'flex-start'} mb={2}>
          <IconBadge icon={icon} size={56} variant="gradient" rounded="18px" />
        </Box>
      ) : null}
      {overline ? (
        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 1,
            px: 1.5,
            py: 0.75,
            mb: 1.5,
            borderRadius: 999,
            bgcolor: alpha(theme.palette.primary.main, 0.08),
            border: `1px solid ${alpha(theme.palette.primary.main, 0.12)}`,
          }}
        >
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              bgcolor: theme.palette.secondary.main,
            }}
          />
          <Typography variant="overline" color="secondary" sx={{ fontWeight: 800, letterSpacing: 1.4, lineHeight: 1 }}>
            {overline}
          </Typography>
        </Box>
      ) : null}
      <Typography variant="h3" component="h2" sx={{ fontWeight: 800, lineHeight: 1.15, mb: subtitle ? 2 : 0 }}>
        {title}
      </Typography>
      {subtitle ? (
        <Typography variant="h6" component="p" color="textSecondary" sx={{ fontWeight: 400, lineHeight: 1.65 }}>
          {subtitle}
        </Typography>
      ) : null}
    </Box>
  );
};

SectionHeader.propTypes = {
  overline: PropTypes.string,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  icon: PropTypes.string,
  align: PropTypes.string,
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default SectionHeader;
